import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { UserWarningModel } from 'app/models/user_warning.model';

@Injectable({ providedIn: 'root' })
export class UserWarningService extends BaseService<UserWarningModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'userWarning');
    }
}
